import t from "./_copyObject.js";
import o from "./keysIn.js";
function i(n, r) {
  return n && t(r, o(r), n);
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseAssignIn.js
// module id = 1422
// module chunks = 41